import React, {
  forwardRef,
  useEffect,
  useImperativeHandle,
  useState,
} from "react";
import { Search as SearchIcon, GridOn as ExcelIcon, BlockOutlined } from "@mui/icons-material";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Typography,
  TablePagination,
  Box,
  Chip,
  Tooltip,
  IconButton,
  Button,
  TextField,
  InputAdornment,
  Stack,
  MenuItem,
} from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { fetchOpenCollection } from "../../../redux/slices/dashSlice";
import {
  LocalOfferOutlined,
  CodeOutlined,
  CategoryOutlined,
  BarChartOutlined,
  DescriptionOutlined,
  WidgetsOutlined,
  FormatListNumberedOutlined,
  PaletteOutlined,
  ArrowBackIosNew,
} from "@mui/icons-material";
import { FaBoxTissue } from "react-icons/fa";
import { useLocation, useNavigate } from "react-router-dom";
import * as XLSX from "xlsx";
import MainLayout from "../../admin/MainLayout";
import Select from "react-select";
import MultiSelectWithCheckbox from "../../utils/MultiSelectWithCheckbox";
import LoadingIndicator from "../../utils/LoadingIndicator";
import RoleSelect from "../../utils/RoleSelect";
import DateRangeFilter from "../../utils/DateRangeFilter";
import { fetchRegion, fetchState } from "../../../redux/slices/clientSlice";
import FilterBar2 from "../../admin/admin_dashboard/FilterBar2";
import UserService from "../../../Services/UserList";
const FY_MONTH_ORDER = [4, 5, 6, 7, 8, 9, 10, 11, 12, 1, 2, 3];
const roleOptions = [
  { label: "IC", value: 2 },
  { label: "BSP", value: 3 },
  { label: "DSP", value: 4 },
  { label: "BD", value: 5 },
  { label: "Sales Enabler", value: 6 },
  { label: "Dealer", value: 7 },
  { label: "Studio", value: 8 },
];

const CollectionSku = () => {
  const navigate = useNavigate();
  const { state } = useLocation();
  const month = state?.month;

  const dispatch = useDispatch();
  const { openColletionSkus, totalCount, getStatus } = useSelector(
    (state) => state.dash
  );
  const { regionOpt, stateOpt } = useSelector((state) => state.adminOption);
  const [selectedChannels, setSelectedChannels] = useState(state.selectedChannels || []);
  const [searchTerm, setSearchTerm] = useState("");
  const [roleId, setRoleId] = useState(state.role || []);
  const [fromDate, setFromDate] = useState(state.from || null);
  const [toDate, setToDate] = useState(state.to || null);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [selectedUserId, setSelectedUserId] = useState(state.user || []);
  const [channelOpt, setChannelOpt] = useState([]);
  const userOptions = state?.userOptions;
  const [selectedMonth, setSelectedMonth] = useState(
    Array.isArray(month) ? month : month ? [month] : FY_MONTH_ORDER
  );
  const [selectedYear, setSelectedYear] = useState(
    Array.isArray(state.year)
      ? state.year.map(String)
      : state.year
        ? [String(state.year)]
        : [String(new Date().getFullYear())]
  );
  const [selectedState, setSelectedState] = useState(Array.isArray(state.selectedState) ? state.selectedState : state.selectedState ? [state.selectedState] : []);
  const [selectedRegion, setSelectedRegion] = useState(state.selectedRegion || []);

  useEffect(() => {
    dispatch(
      fetchOpenCollection({
        collection: state.collection,
        page: page + 1,
        rowsPerPage,
        search: searchTerm,
        role: roleId,
        user: selectedUserId,
        from: fromDate,
        to: toDate,
        month: fromDate || toDate ? null : selectedMonth,
        year: fromDate || toDate ? null : selectedYear,
        selectedRegion,
        selectedState,
          selectedChannels:selectedChannels

      })
    );
  }, [
    state,
    page,
    rowsPerPage,
    searchTerm,
    roleId,
    fromDate,
    toDate,
    selectedUserId,
    selectedMonth,
    selectedYear,
    selectedState,
    selectedRegion,
    selectedChannels
  ]);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const downloadFile = async () => {
    {
      if (!openColletionSkus || openColletionSkus.length === 0) return;

      const dataToExport = openColletionSkus.map((client, index) => ({
        "S.No.": index + 1,
        "SKU Code": client.sku_code,
        Description: client.product_desc,
        Usage: client.usage_count,
        Brand: client.brand,
        Category: client.category,
        "MRP (₹)": client.mrp,
        Finish: client.finish,
        Type: client.product_typ_group,
      }));

      const ws = XLSX.utils.json_to_sheet(dataToExport);
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, "Clients");
      XLSX.writeFile(wb, "collection_skus.xlsx");
    }
  };

  const handleBackClick = () => navigate(-1);

  const MONTHS_LABELS = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];

  const months = FY_MONTH_ORDER.map((m) => ({
    value: m,
    label: MONTHS_LABELS[m - 1],
  }));

  const currentYear = new Date().getFullYear();
  const startYear = 2023;
  const yearCount = currentYear - startYear + 1;

  const years = Array.from({ length: yearCount }, (_, i) => {
    const year = currentYear - i;
    return {
      value: String(year),
      label: `${year}-${year + 1}`,
    };
  });

  const yearOptions = years.map((y) => ({ label: y.label, value: y.value }));
  const formattedUserOptions = (userOptions || []).map((u) => ({
    label: u.label,
    value: u.value,
  }));

  // Filter Configurations Array for FilterBar2
  const filterConfigs = [
    {
      id: "role",
      label: "Role",
      options: roleOptions,
      selected: roleOptions.filter((s) => roleId.includes(s.value)),
    },
    {
      id: "user",
      label: "Users",
      options: formattedUserOptions,
      selected: formattedUserOptions.filter((u) => selectedUserId.includes(u.value)),
    },
    {
      id: "channel",
      label: "Channel",
      options: channelOpt,
      selected: channelOpt.filter((c) => selectedChannels.includes(c.value)),
    },
    {
      id: "region",
      label: "Region",
      options: regionOpt,
      selected: regionOpt.filter((s) => selectedRegion.includes(s.value)),
    },
    {
      id: "state",
      label: "State",
      options: stateOpt,
      selected: stateOpt.filter((s) => selectedState.includes(s.value)),
    },
    {
      id: "year",
      label: "Year (FY)",
      options: yearOptions,
      selected: yearOptions.filter((y) => selectedYear.includes(y.value)),
    },
  ];

  // Filter Change Callback
  const handleFilterChange = (filterId, nextSelected) => {
    switch (filterId) {
      case "role": {
        const roles = nextSelected.map((r) => (typeof r === "object" ? r.value ?? r.id : r));
        setRoleId(roles);
        break;
      }
      case "user": {
        const userIds = nextSelected.map((u) => (typeof u === "object" ? u.value ?? u.id : u));
        setSelectedUserId(userIds);
        break;
      }
      case "region": {
        const regions = nextSelected.map((r) => (typeof r === "object" ? r.value ?? r.id : r));
        setSelectedRegion(regions);
        setSelectedState([]);
        break;
      }
      case "state": {
        const states = nextSelected.map((s) => (typeof s === "object" ? s.value ?? s.id : s));
        setSelectedState(states);
        break;
      }
      case "year": {
        const selectedYears = nextSelected.map((y) => String(typeof y === "object" ? y.value : y));
        setSelectedYear(selectedYears);
        break;
      }
      default:
        break;
    }
  };

  const handleMonthChange = (event) => {
    const value = event.target.value;
    setSelectedMonth(typeof value === "string" ? value.split(",") : value);
  };

  const handleYearChange = (event) => {
    const value = event.target.value;
    setSelectedYear(typeof value === "string" ? value.split(",") : value);
  };

  const handleClearFilters = () => {
    setSelectedUserId([]);
    setSelectedChannels([]);
    setRoleId(state.role || []);
    setFromDate(state.from || null);
    setToDate(state.to || null);
    setSelectedMonth(Array.isArray(month) ? month : month ? [month] : FY_MONTH_ORDER);
    setSelectedYear(
      Array.isArray(state.year)
        ? state.year.map(String)
        : state.year
          ? [String(state.year)]
          : [String(new Date().getFullYear())]
    );
    setSearchTerm("");
    setSelectedState([]);
    setSelectedRegion(state.region || []);
  }

  useEffect(() => {
    dispatch(fetchRegion());
    UserService.GetChannels().then(response => {
      if (response && response.data) {
        setChannelOpt(response.data.map(ch => ({
          value: ch.id,
          label: ch.channel_name
        })));
      }
    }).catch(console.error);
  }, []);

  return (
    <MainLayout title={"Collection SKU Uses"}>
      <LoadingIndicator show={getStatus === "pending"} />

      <Box
        sx={{
          p: { xs: 1, md: 2 },
          width: "100%",
          maxWidth: "100%",
          overflow: "hidden",
          minHeight: 800,
          mx: "auto",
          // backgroundColor: "#fff",
        }}
      >
        <FilterBar2
          filters={filterConfigs}
          onFilterChange={handleFilterChange}
          selectedMonth={selectedMonth}
          setSelectedMonth={setSelectedMonth}
          searchTerm={searchTerm}
          setSearchTerm={setSearchTerm}
          searchPlaceHolder="Search by SKU, Brand, Category..."
          selectedFromDate={fromDate}
          setSelectedFromDate={setFromDate}
          selectedToDate={toDate}
          setSelectedToDate={setToDate}
          onClearFilters={handleClearFilters}
          actions={
            <div className="flex items-center gap-2">
              <Tooltip title="Back to previous page">
                <IconButton
                  onClick={handleBackClick}
                  size="small"
                  sx={{
                    backgroundColor: "#fff",
                    border: "1px solid #cbd5e1",
                    "&:hover": { backgroundColor: "#f8fafc" },
                  }}
                >
                  <ArrowBackIosNew fontSize="small" />
                </IconButton>
              </Tooltip>

              <Button
                variant="contained"
                startIcon={<ExcelIcon />}
                onClick={downloadFile}
                sx={{
                  height: 32,
                  bgcolor: "#2e7d32",
                  textTransform: "none",
                  borderRadius: 12,
                  fontSize: "12px",
                  px: "14px",
                  "&:hover": { bgcolor: "#1b5e20" },
                }}
              >
                Excel
              </Button>
            </div>
          }
        />
        <Paper sx={{ width: "100%", borderRadius: 2, overflow: "hidden" }}>
          <TableContainer>
            <Table sx={{ minWidth: 750 }} aria-label="G5 price segment table">
              <TableHead sx={{ background: "#04121f", color: "white" }}>
                <TableRow>
                  <TableCell sx={{ color: "#fff", fontWeight: "bold" }}>
                    <Box display="flex" alignItems="center" gap={1}>
                      <FormatListNumberedOutlined /> S. No.
                    </Box>
                  </TableCell>
                  <TableCell sx={{ color: "#fff", fontWeight: "bold" }}>
                    <Box display="flex" alignItems="center" gap={1}>
                      <CodeOutlined /> SKU Code
                    </Box>
                  </TableCell>
                  <TableCell sx={{ color: "#fff", fontWeight: "bold" }}>
                    <Box display="flex" alignItems="center" gap={1}>
                      <BarChartOutlined /> Usage
                    </Box>
                  </TableCell>
                  <TableCell sx={{ color: "#fff", fontWeight: "bold" }}>
                    <Box display="flex" alignItems="center" gap={1}>
                      <LocalOfferOutlined /> Brand
                    </Box>
                  </TableCell>
                  <TableCell sx={{ color: "#fff", fontWeight: "bold" }}>
                    <Box display="flex" alignItems="center" gap={1}>
                      <DescriptionOutlined /> Description
                    </Box>
                  </TableCell>
                  <TableCell sx={{ color: "#fff", fontWeight: "bold" }}>
                    <Box display="flex" alignItems="center" gap={1}>
                      <PaletteOutlined /> Finish
                    </Box>
                  </TableCell>
                  <TableCell sx={{ color: "#fff", fontWeight: "bold" }}>
                    <Box display="flex" alignItems="center" gap={1}>
                      <CategoryOutlined /> Category
                    </Box>
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {openColletionSkus?.length > 0 ? (
                  openColletionSkus.map((product, index) => (
                    <TableRow
                      key={`${product.sku_code}-${index}-${product.usage_count}`}
                      hover
                      sx={{
                        "&:nth-of-type(odd)": { backgroundColor: "#f9fafb" },
                        "&:hover": { backgroundColor: "#eef2ff" },
                        transition: "background-color 0.3s ease",
                        cursor: "pointer",
                      }}
                      onClick={() =>
                        navigate("/admin/sku-uses", {
                          state: {
                            sku: product.sku_code,
                            role: roleId,
                            userOptions: userOptions,
                            from: state.from,
                            to: state.to,
                            month: state.month,
                            year: state.year,
                            selectedRegion: state.selectedRegion,
                            selectedState: state.selectedState,
                          },
                        })
                      }
                    >
                      <TableCell>
                        <Box sx={{ fontWeight: "bold", color: "#4c66f5" }}>
                          {page * rowsPerPage + index + 1}
                        </Box>
                      </TableCell>
                      <TableCell component="th" scope="row">
                        {product.sku_code}
                      </TableCell>
                      <TableCell>
                        <Chip
                          label={`${product.usage_count} Used`}
                          size="small"
                          sx={{
                            backgroundColor: "#e0f2fe",
                            color: "#0288d1",
                            fontWeight: "bold",
                          }}
                        />
                      </TableCell>
                      <TableCell>{product.brand}</TableCell>
                      <TableCell>{product.product_desc}</TableCell>
                      <TableCell>{product.finish}</TableCell>
                      <TableCell>{product.category}</TableCell>
                    </TableRow>
                  ))
                ) : (
                  <TableRow>
                    <TableCell colSpan={7} align="center">
                      <Typography
                        variant="subtitle1"
                        color="text.secondary"
                        sx={{ py: 2 }}
                      >
                        No data available
                      </Typography>
                    </TableCell>
                  </TableRow>
                )}
              </TableBody>
            </Table>
          </TableContainer>
          <TablePagination
            rowsPerPageOptions={[5, 10, 25, totalCount || 0]}
            component="div"
            count={totalCount || 0}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
          />
        </Paper>
      </Box>
    </MainLayout>
  );
};

export default CollectionSku;
